import { forwardRef, InputHTMLAttributes } from 'react'

import { cn } from '@/ui/utils/style'

interface SlippageInputProps extends InputHTMLAttributes<HTMLInputElement> {
  isActive: boolean
  error?: string
}

const decimalNumberRegex = /^\d+\.?\d*$/

export const SlippageInput = forwardRef<HTMLInputElement, SlippageInputProps>(
  ({ isActive, error, onChange, ...rest }, ref) => {
    return (
      <div
        className={cn(
          'flex items-center gap-3 p-2 pr-4',
          'rounded-sm border border-primary bg-secondary',
          'h-12',
          isActive && 'border border-tertiary',
          error && 'border-error-200 bg-system-error-primary',
        )}
      >
        <input
          className={cn(
            'typography-label-2 text-primary focus:outline-hidden',
            'flex h-full w-full',
            error && 'outline-error',
          )}
          maxLength={6}
          ref={ref}
          placeholder="Custom"
          type="text"
          inputMode="decimal"
          {...rest}
          onChange={(e) => {
            e.target.value = e.target.value.replace(/,/g, '.')
            if (!e.target.value || decimalNumberRegex.test(e.target.value)) {
              onChange?.(e)
            }
          }}
        />
        <div className="typography-label-2 text-secondary">%</div>
      </div>
    )
  },
)
SlippageInput.displayName = 'SlippageInput'
